// src/components/More.js - BETA VERSION (Simplified)
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';

function More() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const userRole = user?.role;

  const handleLogout = () => {
    logout();          // clears the real token (ams_user) + auth state, same as desktop
    navigate('/login');
  };

  const menuSections = [
    {
      title: '👤 Account',
      items: [
        { label: 'My Profile', path: '/profile', icon: '👤', roles: ['admin', 'coach', 'athlete'] },
      ]
    },
    {
      title: '🏋️ Gym Operations',
      items: [
        { label: 'Schedule', path: '/calendar', icon: '🗓', roles: ['admin', 'coach', 'athlete', 'parent'] },
        { label: 'Manage Classes', path: '/class-management', icon: '📚', roles: ['admin', 'coach'] },
        { label: 'Attendance Tracking', path: '/attendance', icon: '✅', roles: ['admin', 'coach'] },
        { label: 'Waivers & Forms', path: '/waivers', icon: '📝', roles: ['admin', 'coach'] },
        { label: 'Communication Hub', path: '/communication', icon: '💬', roles: ['admin', 'coach'] },
      ]
    },
    {
      title: '🏥 Health & Safety',
      items: [
        { label: 'Medical Profiles', path: '/medical-profile', icon: '🏥', roles: ['admin', 'coach'] },
      ]
    },
    {
      title: '🏆 Competition Management',
      items: [
        { label: 'Meet Coordination', path: '/meet-coordination', icon: '🏆', roles: ['admin'] },
      ]
    },
    {
      title: '💰 Financial Management',
      items: [
        { label: 'Financial Reports', path: '/financial-reports', icon: '💰', roles: ['admin'] },
      ]
    }
  ];

  return (
    <div style={{ padding: '1.5rem', maxWidth: '800px', margin: '0 auto', paddingBottom: '80px' }}>
      <h1 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '2rem' }}>⚙️ Settings</h1>

      {/* Beta Notice */}
      <div style={{
        background: '#dbeafe',
        border: '1px solid #3b82f6',
        borderRadius: '12px',
        padding: '1rem 1.25rem',
        marginBottom: '2rem'
      }}>
        <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#1e40af', marginBottom: '0.5rem' }}>
          🚀 Beta Version
        </h3>
        <p style={{ fontSize: '0.875rem', color: '#1e3a8a', margin: 0 }}>
          You're using the simplified beta version. Advanced features are available in development mode.
        </p>
      </div>

      {menuSections.map((section, idx) => {
        const visibleItems = section.items.filter(item => 
          !item.roles || item.roles.includes(userRole)
        );

        if (visibleItems.length === 0) return null;

        return (
          <div key={idx} style={{ marginBottom: '2rem' }}>
            <h2 style={{ 
              fontSize: '0.875rem', 
              fontWeight: '600', 
              color: '#6b7280', 
              textTransform: 'uppercase',
              marginBottom: '1rem',
              letterSpacing: '0.05em'
            }}>
              {section.title}
            </h2>
            <div style={{
              background: 'white',
              borderRadius: '12px',
              border: '1px solid #e5e7eb',
              overflow: 'hidden'
            }}>
              {visibleItems.map((item, itemIdx) => (
                <Link
                  key={itemIdx}
                  to={item.path}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '1rem 1.25rem',
                    textDecoration: 'none',
                    color: '#111827',
                    borderBottom: itemIdx < visibleItems.length - 1 ? '1px solid #f3f4f6' : 'none',
                    transition: 'background 0.2s'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.background = '#f9fafb'}
                  onMouseOut={(e) => e.currentTarget.style.background = 'white'}
                >
                  <span style={{ fontSize: '1.5rem', marginRight: '1rem' }}>{item.icon}</span>
                  <span style={{ flex: 1, fontWeight: '500' }}>{item.label}</span>
                  <span style={{ color: '#9ca3af' }}>›</span>
                </Link>
              ))}
            </div>
          </div>
        );
      })}

      {/* App Info */}
      <div style={{ marginTop: '2rem', marginBottom: '2rem' }}>
        <div style={{
          background: 'white',
          borderRadius: '12px',
          border: '1px solid #e5e7eb',
          padding: '1rem 1.25rem'
        }}>
          <p style={{ fontSize: '0.875rem', color: '#6b7280', margin: 0 }}>
            <strong>App Version:</strong> Beta 1.0
          </p>
          <p style={{ fontSize: '0.875rem', color: '#6b7280', margin: '0.5rem 0 0 0' }}>
            <strong>Mode:</strong> Production
          </p>
        </div>
      </div>

      {/* Logout Button */}
      <div style={{ marginTop: '3rem' }}>
        <button
          onClick={handleLogout}
          style={{
            width: '100%',
            padding: '1rem',
            background: '#ef4444',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background 0.2s'
          }}
          onMouseOver={(e) => e.currentTarget.style.background = '#dc2626'}
          onMouseOut={(e) => e.currentTarget.style.background = '#ef4444'}
        >
          🚪 Logout
        </button>
      </div>
    </div>
  );
}

export default More;
